var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1363 17.8793C15.9043 16.0685 14.3027 14.6667 12.3615 14.6667H10.4597C8.51854 14.6667 6.917 16.0685 6.68501 17.8793M16.1363 17.8793C18.446 16.4019 19.9687 13.8724 19.9687 11C19.9687 6.44365 16.1371 2.75 11.4106 2.75C6.68413 2.75 2.85254 6.44365 2.85254 11C2.85254 13.8724 4.37528 16.4019 6.68501 17.8793M16.1363 17.8793C14.7821 18.7455 13.1575 19.25 11.4106 19.25C9.66376 19.25 8.03914 18.7455 6.68501 17.8793M14.2633 9.16667C14.2633 10.6854 12.9861 11.9167 11.4106 11.9167C9.83513 11.9167 8.55793 10.6854 8.55793 9.16667C8.55793 7.64788 9.83513 6.41667 11.4106 6.41667C12.9861 6.41667 14.2633 7.64788 14.2633 9.16667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerIcon1);
export default __webpack_public_path__ + "static/media/drawer-icon-1.db7fa406fb5d919991f91d210fccedf8.svg";
export { ForwardRef as ReactComponent };